import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.scss';

function onKeyPress(e) {
	if (e.key === 'Enter') {
		e.preventDefault()
		e.target.blur()
	}
}
const Textbox = props =>
	<input
		className={styles.input}
		placeholder={props.placeholder}
		autoComplete={props.autoComplete}
		name={props.name}
		value={props.value}
		onChange={event => props.handleInput(event)}
		onBlur={event => props.handleInput(event)}
		onKeyPress={event => onKeyPress(event)}
	/>

Textbox.defaultProps = {
	placeholder: '',
	autoComplete: ''
}

Textbox.propTypes = {
	name: PropTypes.string.isRequired,
	handleInput: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	autoComplete: PropTypes.string
}

export default Textbox